module.exports = __webpack_public_path__ + "assets/img/customer-2.371102d2.png";